import { AccordionProvider } from "domain/accordion";
import React from "react";
import { WithChildren } from "types";

const ApplicationContext = React.createContext(null);

export const ApplicationContextProvider = ({ children }: WithChildren) => {
  return (
    <ApplicationContext.Provider value={null}>
      {/* All context providers will be nested here */}
      <AccordionProvider>{children}</AccordionProvider>
    </ApplicationContext.Provider>
  );
};
